import React from 'react';
import './Page.less';
import './Program.less';
import '../components/Table.less';
import BackBtn from '../components/UI/BackBtn';

// Данные для таблицы индикаторов программы
const programIndicatorsData = {
  headers: ["Индекс", "Наименование показателя", "Ед. изм.", "2025", "2026", "2027", "2028", "2029", "2030", "2036"],
  rows: [
    {
      id: "ЦПЭ1",
      name: "Доля внутренних затрат на исследования и разработки в общем объеме бюджета университета",
      unit: "%",
      values: ["19", "19.3", "19.8", "20.6", "21.6", "23", "26"]
    },
    {
      id: "ЦПЭ2",
      name: "Доля доходов из внебюджетных источников в общем объеме доходов университета",
      unit: "%",
      values: ["44.5", "45", "45.5", "47", "49", "53", "56"]
    },
    {
      id: "ЦПЭ3", 
      name: "Удельный вес молодых ученых, имеющих ученую степень кандидата наук или доктора наук в общей численности научно-педагогических работников",
      unit: "%",
      values: ["7.5", "7.8", "8.1", "8.4", "8.9", "10", "15"]
    },
    {
      id: "ЦПЭ4",
      name: "Средний балл ЕГЭ по отраслевому направлению университета",
      unit: "балл",
      values: ["78.9", "79.1", "79.3", "79.5", "79.7", "80", "82"]
    },
    {
      id: "ЦПЭ5",
      name: "Удельный вес численности иностранных граждан и лиц без гражданства в общей численности обучающихся по образовательным программам высшего образования",
      unit: "%",
      values: ["9.8", "10", "10.2", "10.5", "11", "12", "15"]
    },
    {
      id: "ЦПЭ6",
      name: "Уровень трудоустройства выпускников, уровень их востребованности на рынке труда и уровень их заработной платы",
      unit: "%",
      values: ["0", "0", "0", "0", "0", "0", "0"]
    },
    {
      id: "ЦПЭ7",
      name: "Удельный вес объема финансирования, привлеченного в фонды целевого капитала, в общем объеме внебюджетных средств университета",
      unit: "%",
      values: ["0.35", "0.36", "0.37", "0.38", "0.39", "0.4", "0.5"]
    },
    {
      id: "ЦПЭ8",
      name: "Удельный вес работников административно-управленческого и вспомогательного персонала в общей численности работников университета",
      unit: "%",
      values: ["49.85", "50.8", "50.2", "50", "49.8", "49.5", "46"]
    },
    {
      id: "ЦПЭ9",
      name: "Удельный вес оплаты труда работников административно-управленческого и вспомогательного персонала в фонде оплаты труда университета",
      unit: "%",
      values: ["43.8", "43.3", "42.7", "42.1", "41.2", "40", "38"]
    },
    {
      id: "ЦПЭ10", 
      name: "Индекс технологического лидерства",
      unit: "балл",
      values: ["7.597", "8.564", "9.233", "10.251", "12.409", "13.894", "23.073"]
    }
  ]
};

// Компонент для отображения таблицы индикаторов программы
const ProgramIndicatorsTable = () => {
  return (
    <div className="table table-special2 extra-table">
      <table>
        <thead>
          <tr>
            {programIndicatorsData.headers.map((header, index) => (
              <th key={index} style={{ padding: '16px', textAlign: index > 2 ? 'center' : 'left' }}><span>{header}</span></th>
            ))}
          </tr>
        </thead>
        <tbody>
          {programIndicatorsData.rows.map((row, index) => (
            <tr key={index}>
              <td style={{textAlign: 'center'}}><span>{row.id}</span></td>
              <td className='extra-table-tdname'><span>{row.name}</span></td>
              <td style={{ textAlign: 'center' }}><span>{row.unit}</span></td>
              {row.values.map((value, valueIndex) => (
                <td key={valueIndex} style={{ textAlign: 'center' }}><span>{value}</span></td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default function ProgramIndicators() {
  return (
    <section className="page program-page program-page-indicators">
      <div className="container">
        <BackBtn />
        <h2>Целевые показатели эффективности реализации Программы развития УрФУ</h2>
        <ProgramIndicatorsTable />
      </div>
    </section>
  );
}
